<div class="auth-wrapper auth-v1 px-2 col-12">
  <div class="auth-inner py-2 col-12 custom-auth-inner">
    <!-- Login v1 -->
    <div class="card mb-0">
      <div class="card-header justify-content-center bg-secondary">
        <a href="#" target="_self" class="brand-logo mb-0 mt-0">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="50"/>
        </a>
      </div>
      <div class="card-body pt-2">
        <h4 class="card-title mb-1">Registra la tua azienda su Tulero</h4>
        <p class="card-text mb-2">Compila i seguenti campi per registrare la tua azienda.</p>

        <form [formGroup]="businessRegistration" (ngSubmit)="onSubmit()" class="d-flex flex-column col-12">
          <div class="container d-flex flex-column col-12">
            <div class=" container col-12 d-flex flex-column">
              <h3>Dettagli Aziendali</h3>
              <div class="form-section d-flex flex-row">
                <div class="col-12 form-group">
                  <label class="label" for="name">Ragione Sociale:</label>
                  <input id="name" class="form-control" formControlName="name" placeholder="Ragione Sociale">
                </div>
              </div>
              <div class="form-section d-flex flex-row">
                <div class="col-6 form-group">
                  <label class="label" for="vatNumber">Partita IVA:</label>
                  <input id="vatNumber" class="form-control" formControlName="vatNumber" placeholder="Partita IVA">

                </div>
                <div class="col-6 form-group">
                  <label class="label" for="fiscalCode">Codice Fiscale:</label>
                  <input id="fiscalCode" class="form-control" formControlName="fiscalCode" placeholder="Codice Fiscale">

                </div>
              </div>
              <div class="form-section d-flex flex-row">
                <div class="col-6 form-group">
                  <label class="label" for="uniqueCode">Codice Unico:</label>
                  <input id="uniqueCode" class="form-control" formControlName="uniqueCode" placeholder="Codice Unico">

                </div>


                <div class="col-6 form-group">
                  <label class="label" for="pec">PEC (Posta Elettronica Certificata):</label>
                  <input id="pec" class="form-control" formControlName="pec" placeholder="PEC">

                </div>
              </div>
            </div>
            <div class="container col-12 d-flex flex-column">
              <h3>Indirizzo</h3>
              <div class="form-section d-flex flex-row">
                <div class="col-6 form-group">
                  <label class="label" for="location.legalStreet">Indirizzo:</label>
                  <input id="location.legalStreet" class="form-control" formControlName="legalStreet"
                         placeholder="Indirizzo">

                </div>
                <div class="col-3 form-group">
                  <label class="label" for="legalNumber">Numero Civico:</label>
                  <input id="legalNumber" class="form-control" formControlName="legalNumber"
                         placeholder="Numero Civico:">
                </div>

                <div class="col-3 form-group">
                  <label class="label" for="legalZipCode">CAP:</label>
                  <input id="legalZipCode" class="form-control" formControlName="legalZipCode"
                         placeholder="CAP">

                </div>
              </div>
              <div class="form-section d-flex flex-row">
                <div class="col-4 form-group">
                  <label class="label" for="legalCity">Città:</label>
                  <input id="legalCity" class="form-control" formControlName="legalCity"
                         placeholder="Città">

                </div>
                <div class="col-2 form-group">
                  <label class="label" for="legalProvince">Provincia:</label>
                  <input id="legalProvince" class="form-control" formControlName="legalProvince"
                         placeholder="RM">

                </div>
                <div class="col-3 form-group">
                  <label class="label" for="legalRegion">Regione:</label>
                  <input id="legalRegion" class="form-control" formControlName="legalRegion"
                         placeholder="Regione">

                </div>
                <div class="same-address col-3 form-group">
                  <input type="checkbox" class="custom-control-input" id="isSameAddress" (change)="onCheckboxChange()"/>
                  <label class="custom-control-label text-secondary cursor-pointer" for="isSameAddress">Destinazione diversa per la consegna</label>
                </div>
              </div>

            </div>
          </div>
          <div class="container d-flex flex-column col-12">
            <div *ngIf="!sameAddress" class="container col-12 d-flex flex-column">
              <h3>Indirizzo di consegna</h3>
              <div class="form-section d-flex flex-row">
                <div class="col-6 form-group">
                  <label class="label" for="Street">Indirizzo:</label>
                  <input id="Street" class="form-control" formControlName="Street"
                         placeholder="Indirizzo">

                </div>
                <div class="col-3 form-group">
                  <label class="label" for="Number">Numero Civico:</label>
                  <input id="Number" class="form-control" formControlName="Number"
                         placeholder="Numero Civico:">
                </div>

                <div class="col-3 form-group">
                  <label class="label" for="ZipCode">CAP:</label>
                  <input id="ZipCode" class="form-control" formControlName="ZipCode"
                         placeholder="CAP">

                </div>
              </div>
              <div class="form-section d-flex flex-row">
                <div class="col-4 form-group">
                  <label class="label" for="City">Città :</label>
                  <input id="City" class="form-control" formControlName="City"
                         placeholder="Città">

                </div>
                <div class="col-2 form-group">
                  <label class="label" for="Province">Provincia:</label>
                  <input id="Province" class="form-control" formControlName="Province"
                         placeholder="RM">
                </div>
                <div class="col-3 form-group">
                  <label class="label" for="Region">Regione:</label>
                  <input id="Region" class="form-control" formControlName="Region"
                         placeholder="Regione">
                </div>
              </div>
            </div>
          </div>
          <button class="submit" type="submit">Registrati</button>
        </form>


        <p class="text-center mt-2">
          <span>Vuoi scegliere tra le tue aziende?</span>
          <a routerLink="/authentication/business-selection">
            <span class="text-primary cursor-pointer">&nbsp;Lista aziende</span>
          </a>
        </p>

      </div>
    </div>
    <!-- /Login v1 -->
  </div>
</div>
